import { useQuery, UseQueryFunctionResult } from "@lookiero/messaging-react";
import {
  ViewIsSalesOfferingEnabledResult,
  viewIsSalesOfferingEnabled,
} from "../../../../projection/offering/viewIsSalesOfferingEnabled";
import { MESSAGING_CONTEXT_ID } from "../../../delivery/baseBootstrap";

interface UseViewIsSalesOfferingEnabledFunction {
  (): UseQueryFunctionResult<ViewIsSalesOfferingEnabledResult>;
}

const useViewIsSalesOfferingEnabled: UseViewIsSalesOfferingEnabledFunction = () =>
  useQuery({
    query: viewIsSalesOfferingEnabled(),
    contextId: MESSAGING_CONTEXT_ID,
    options: {
      staleTime: Infinity,
      retry: false,
      refetchOnWindowFocus: false,
    },
  });

export { useViewIsSalesOfferingEnabled };
